/* Track Event after form submit and before backend submit */
import type { FormDetailsValues } from '../components/signupForm/types';

const trackSignupClickAfterValidation = async (signupForm: FormDetailsValues) => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'LeadCreated',
    data: {
      lead_creation_source_type: 'company',
      company_name: signupForm.companyName,
      email: signupForm.email,
      number_employees: signupForm.numberEmployees,
      phone: signupForm.phone.replace(/\D/g, ''),
      trigger: 'form button',
    },
  });
};

export default trackSignupClickAfterValidation;
